import { render, staticRenderFns } from "./SummaryProducts.vue?vue&type=template&id=78abef96&scoped=true&"
import script from "./SummaryProducts.vue?vue&type=script&lang=ts&"
export * from "./SummaryProducts.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryProducts.vue?vue&type=style&index=0&id=78abef96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78abef96",
  null
  
)

export default component.exports